import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ManageBranchService } from "../api/services";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const StudentCallLogs = () => {
  const navigate = useNavigate();
  const { user_id } = useParams();
  const thStyle = {
  padding: "12px",
  fontWeight: "600"
};

const tdStyle = {
  padding: "12px",
  textAlign: "center",
  border: "1px solid #e5e7eb",
  color: "#111827",
  fontSize: "14px",
};



  // --------------------------------------
  // STATE DECLARATIONS
  // --------------------------------------
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [showPickerModal, setShowPickerModal] = useState(false);

  const [monthlyTransactions, setMonthlyTransactions] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  // --------------------------------------
  // HELPERS
  // --------------------------------------
  const [totalTransactions, setTotalTransactions] = useState(0);

  const getMonthLabel = (date) =>
    date.toLocaleString("default", { month: "long", year: "numeric" });

  const formatMonthYear = (date) => {
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const y = date.getFullYear();
    return `${m}-${y}`;
  };

  // --------------------------------------Tr
  // FETCH MONTHLY API
  // --------------------------------------
  const fetchTransactionsForMonth = (userId, date) => {
    debugger;
    const payload = {
      user_id: userId,
      month: formatMonthYear(date),
    };

    setIsLoading(true);

    ManageBranchService.GetStudentCallLogs(payload)
      .then((res) => {
        const monthly = res.data.results || [];
      

        setMonthlyTransactions(monthly);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Fetch failed:", err);
        setMonthlyTransactions([]);
        setIsLoading(false);
      });
  };

  // --------------------------------------
  // CHANGE MONTH
  // --------------------------------------
  const handleMonthChange = (direction) => {
    const newDate = new Date(selectedMonth);
    newDate.setMonth(newDate.getMonth() + direction);

    setSelectedMonth(newDate);
    fetchTransactionsForMonth(user_id, newDate);
  };

  // --------------------------------------
  // ON LOAD
  // --------------------------------------
  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    if (!token) navigate("/");

    if (!user_id) {
      console.error("User ID not found in route params");
      navigate(-1);
      return;
    }

    fetchTransactionsForMonth(user_id, selectedMonth);
  }, []);

  // --------------------------------------
  // MONTH PICKER MODAL
  // --------------------------------------
  const renderDatepickerModal = () =>
    showPickerModal && (
      <div className="modal d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">Select Month</h5>
              <button className="btn-close" onClick={() => setShowPickerModal(false)} />
            </div>

            <div className="modal-body text-center">
              <DatePicker
                selected={selectedMonth}
                onChange={(date) => setSelectedMonth(date)}
                showMonthYearPicker
                dateFormat="MM/yyyy"
                inline
              />
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowPickerModal(false)}>
                Cancel
              </button>

              <button
                className="btn btn-primary"
                onClick={() => {
                  fetchTransactionsForMonth(user_id, selectedMonth);
                  setShowPickerModal(false);
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    );

  // --------------------------------------
  // UI
  // --------------------------------------
  return (
    <div className="container mt-4">
      {/* Loader */}
      {isLoading && (
        <div className="loader">
          <div className="lds-spinner">
            {Array(12)
              .fill()
              .map((_, i) => (
                <div key={i}></div>
              ))}
          </div>
        </div>
      )}

      <button className="btn btn-outline-secondary mb-3" onClick={() => navigate(-1)}>
        ← Back
      </button>

     {/* MONTHLY TRANSACTIONS HEADER */}
<div
  style={{
    background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
    padding: "18px 20px",
    borderRadius: "16px",
    marginBottom: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    color: "white",
    boxShadow: "0 4px 6px rgba(0,0,0,0.12)",
  }}
>
  {/* TITLE */}
  <h5
    style={{
      margin: 0,
      fontWeight: "600",
      fontSize: "16px",
    }}
  >
    Monthly Transactions
  </h5>

  {/* MONTH CONTROLS */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "14px",
    }}
  >
    <button
      className="btn btn-outline-light btn-sm rounded-circle border-0"
      onClick={() => handleMonthChange(-1)}
      aria-label="Previous month"
    >
      <FaArrowLeft />
    </button>

    <span
      onClick={() => setShowPickerModal(true)}
      style={{
        fontWeight: "700",
        fontSize: "15px",
        cursor: "pointer",
        padding: "6px 16px",
        borderRadius: "20px",
        background: "rgba(255,255,255,0.2)",
      }}
    >
      {getMonthLabel(selectedMonth)}
    </span>

    <button
      className="btn btn-outline-light btn-sm rounded-circle border-0"
      onClick={() => handleMonthChange(1)}
      aria-label="Next month"
    >
      <FaArrowRight />
    </button>
  </div>
</div>

      

      {/* Monthly Table */}
       <div
            style={{
              marginTop: "30px",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "16px",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            }}
          >
        <table  style={{ width: "100%", borderCollapse: "collapse" }}>
         <thead>
            <tr style={{
                      background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
                      textAlign: "center",
                      color: "white"
                    }}>
              <th style={thStyle}>Card Number</th>
              <th style={thStyle}>Mobile</th>
              <th style={thStyle}>Terminal</th>
              <th style={thStyle}>Call on</th>
              <th style={thStyle}>Call Duration</th>
              <th style={thStyle}>Call Charges</th>
            </tr>
          </thead>



          <tbody>
            {monthlyTransactions.length > 0 ? (
              monthlyTransactions.map((txn) => (
                <tr key={txn.transaction_id}>
                  <td style={tdStyle}>{txn.card_no}</td>
                  <td style={tdStyle}>{txn.mobile}</td>
                  <td style={tdStyle}>{txn.terminal}</td>
                  <td style={tdStyle}>{txn.call_sarted_at}</td>
                  <td style={tdStyle}>{txn.call_durition} sec</td>
                  <td style={tdStyle}>{txn.call_chages}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td  className="text-center" colSpan="6">No transactions found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {renderDatepickerModal()}
    </div>
  );
};

export default StudentCallLogs;